module.exports = __webpack_public_path__ + "img/c_photo_1@2x.3440467b.png";